<template>
  <div>
    <v-dialog
      v-model="addEditDialog"
      persistent
      max-width="700px"
      transition="slide-y-transition"
    >
      <v-card class="dialog-card-border">
        <v-card-title class="text-h6 font-weight-light">
          {{ editMode ? $t('Update Customer') : $t('Add New Customer') }}
        </v-card-title>

        <validation-observer
          ref="theForm"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            autocomplete="off"
            @submit.prevent="handleSubmit(submit)"
            @reset.prevent="reset"
          >
            <v-card-text>
              <v-row no-gutters>
                <v-col
                  class="px-1"
                  cols="12"
                >
                  <app-branch-select v-model="formData.branch_id" />
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Name')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="formData.name"
                      :label="`* ${$t('Name')}`"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Phone 1')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="formData.phone1"
                      :label="`* ${$t('Phone 1')}`"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Phone 2')"
                  >
                    <v-text-field
                      v-model="formData.phone2"
                      :label="$t('Phone 2')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Occupation')"
                  >
                    <v-text-field
                      v-model="formData.occupation"
                      :label="$t('Occupation')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Address')"
                  >
                    <v-text-field
                      v-model="formData.address"
                      :label="$t('Address')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Guarantor Name')"
                  >
                    <v-text-field
                      v-model="formData.guarantor_name"
                      :label="$t('Guarantor Name')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Guarantor Phone')"
                  >
                    <v-text-field
                      v-model="formData.guarantor_phone"
                      :label="$t('Guarantor Phone')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Guarantor Address')"
                  >
                    <v-text-field
                      v-model="formData.guarantor_address"
                      :label="$t('Guarantor Address')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Guarantor Occupation')"
                  >
                    <v-text-field
                      v-model="formData.guarantor_occupation"
                      :label="$t('Guarantor Occupation')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Guarantor Place')"
                  >
                    <v-text-field
                      v-model="formData.guarantor_place"
                      :label="$t('Guarantor Place')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Guarantor Number')"
                  >
                    <v-text-field
                      v-model="formData.guarantor_number"
                      :label="$t('Guarantor Number')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Document')"
                  >
                    <v-text-field
                      v-model="formData.document"
                      :label="$t('Document')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Note')"
                  >
                    <v-text-field
                      v-model="formData.note"
                      :label="$t('Note')"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions class="py-3">
              <app-form-tip />

              <v-spacer />

              <v-btn
                depressed
                outlined
                small
                @click="closeDialog()"
              >
                {{ $t('Cancel') }}
              </v-btn>

              <app-submit-button :edit-mode="editMode" />
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    addEditDialog: { type: Boolean, default: false },
    formData: { type: Object, default: () => { } },
    editMode: { type: Boolean, default: false },
  },

  methods: {
    closeDialog() {
      this.$refs.theForm.reset()
      this.$emit('close')
    },

    submit() {
      if (this.editMode) {
        axios.put(`customer/${this.formData.id}/`, this.formData).then(() => {
          this.$_notify('Updated successfully')
          this.closeDialog()
          this.$emit('update-table-data')
        })
      } else {
        axios.post('customer/', this.formData).then(() => {
          this.$_notify('Added successfully')
          this.closeDialog()
          this.$emit('reset-table-data')
        })
      }
    }
  },
}
</script>
